(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-modal-list"] && !Shopify.designMode) return;
  try {
    
  class InfoModalList extends HTMLElement {
    constructor() {
      super();
      this.dialogs = this.querySelectorAll('.sl-modal-overlay');
      this.triggers = this.querySelectorAll('.info-modal-trigger');
      
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const targetId = trigger.getAttribute('data-modal-target');
          const dialog = document.getElementById(targetId);
          if (dialog) {
            dialog.style.display = 'flex';
            trigger.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';

            // Autoplay assembly videos on open
            const assemblyVideos = dialog.querySelectorAll('.assembly-modal-video');
            assemblyVideos.forEach(v => {
              const toggleBtn = v.nextElementSibling;
              
              const playVideo = () => {
                const playPromise = v.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then(() => {
                      if (toggleBtn && toggleBtn.classList.contains('assembly-modal-video-toggle')) {
                        toggleBtn.classList.add('is-playing');
                      }
                    })
                    .catch(err => {
                      console.log("Autoplay failed or was prevented:", err);
                      if (toggleBtn && toggleBtn.classList.contains('assembly-modal-video-toggle')) {
                        toggleBtn.classList.remove('is-playing');
                      }
                    });
                } else {
                  if (toggleBtn && toggleBtn.classList.contains('assembly-modal-video-toggle')) {
                    if (v.paused) {
                      toggleBtn.classList.remove('is-playing');
                    } else {
                      toggleBtn.classList.add('is-playing');
                    }
                  }
                }
              };

              // Try immediately (with user gesture)
              playVideo();
              
              // Also try after transition to ensure visibility
              setTimeout(playVideo, 300);
            });
          }
        });
      });

      this.dialogs.forEach(dialog => {
        const closeBtns = dialog.querySelectorAll('[data-modal-close]');
        closeBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            this.closeDialog(dialog);
          });
        });

        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) {
            this.closeDialog(dialog);
          }
        });
      });

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.dialogs.forEach(dialog => {
            if (dialog.style.display === 'flex') {
              this.closeDialog(dialog);
            }
          });
        }
      });

      // Play/pause toggling is handled by the shared <video-play-toggle> component
    }

    closeDialog(dialog) {
      const videos = dialog.querySelectorAll('video');
      videos.forEach(v => {
        v.pause();
        const toggleBtn = v.nextElementSibling;
        if (toggleBtn && toggleBtn.classList.contains('assembly-modal-video-toggle')) {
          toggleBtn.classList.remove('is-playing');
        }
      });
      
      const trigger = this.querySelector(`[data-modal-target="${dialog.getAttribute('id')}"]`);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      dialog.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('info-modal-list')) {
    customElements.define('info-modal-list', InfoModalList);
  }

  } catch(e) { console.error(e); }
})();
})();
